import { PHONE_SHOWED_STORAGE_KEY } from '../../../constants/lastHopePopup';
import { setNewbuildingIdInStorage } from './setNewbuildingIdInStorage';

export function setUserOpenedPhoneInNewobject(newobjectId: number): void {
  setNewbuildingIdInStorage(PHONE_SHOWED_STORAGE_KEY, newobjectId);
}
